import PopupForm from "app/common/Component/Popup/PopupForm";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { useStore } from "app/stores";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { pagingDepartment } from "app/services/DepartmentService";

import { pagingStaff } from "app/services/StaffService";
import { getCurrentStaff, getDepartmentsUser, isAdmin } from "app/common/LocalFunction";

import * as Yup from 'yup';
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
const PopupNotePatient = ({ open, handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { selectedNote, handleCreateOrEditNotePatient, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const currentUser = getCurrentStaff();
  const departmentsUser = getDepartmentsUser();
  const isAdmins = isAdmin()
  const defaultDepartment =
  !isAdmins
    ? departmentsUser?.find(
        (dep) => dep.id === currentUser?.department?.id
      ) || departmentsUser?.[0] 
    : selectedNote?.department || null;

  const validationSchema = Yup.object().shape({
          content: Yup.string().required("Trường này bắt buộc nhập").nullable(),
          noteCreator: Yup.object().required("Trường này bắt buộc nhập").nullable(),
          
      });
  return (
    <PopupForm
      open={open}
      handleClose={handleClose}
      size="sm"
      title={"Thêm mới ghi chú"}
      formik={{
        initialValues: {
          ...selectedNote,
          patientId: initialPatient?.patientInfo?.id || null,
          noteCreator: !isAdmins ? currentUser : selectedNote?.noteCreator || null,
          department: defaultDepartment,
          noteDate: new Date()
        },
        enableReinitialize: true,
        onSubmit: (values) => {
          console.log("🚀 ~ PopupNotePatient ~ values:", values)
          handleCreateOrEditNotePatient(values);
        },
        validationSchema: validationSchema
      }}
    >
      {({ values }) => (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <GlobitsTextField
                label="Nội dung ghi chú"
                name="content"
                required
                isTextArea
              />
            </Grid>
            {/* <Grid item xs={12}>
              <GlobitsTextField
                label="Chú thích"
                name="remark"
                isTextArea
              />
            </Grid> */}
            <Grid item xs={12}>
              <GlobitsPagingAutocomplete
                label={"Cơ sở"}
                name="department"
                api={
                  isAdmins
                    ? pagingDepartment
                    : async () => ({
                        data: {
                          content: departmentsUser || [],
                          totalElements: departmentsUser?.length || 0,
                          totalPages: 1,
                        },
                      })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <GlobitsPagingAutocomplete
                label={"Người ghi chú"}
                name="noteCreator"
                api={pagingStaff}
                getOptionLabel={(option) => option?.staffName || ""}
                disabled={!isAdmins}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <GlobitsDateTimePicker
                name="noteDate"
                label="Thời gian ghi chú"
                className="mt-2"
                disabled
                isDateTimePicker
              />
            </Grid>
          </Grid>
        </>
      )}
    </PopupForm>
  );
};

export default memo(observer(PopupNotePatient));
